import { render, staticRenderFns } from "./tour-order-detail.vue?vue&type=template&id=2e7d57bf&scoped=true&"
import script from "./tour-order-detail.vue?vue&type=script&lang=js&"
export * from "./tour-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./tour-order-detail.vue?vue&type=style&index=0&id=2e7d57bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d57bf",
  null
  
)

export default component.exports